import React from "react";
import styles from "./styles";
import { connect } from "react-redux";
import * as actionsPresentacion from "../../actions/nuevaPresentacion";
import { withRouter } from "react-router";
import {
    Container,
    Typography,
    Backdrop,
    CircularProgress,
    Box,
} from "@material-ui/core";

import DatosPrestador from "./Secciones/DatosPrestador/DatosPrestador";
import TipoPresentacion from "./Secciones/TipoPresentacion/TipoPresentacion";
import Comprobantes from "./Secciones/Comprobantes/Comprobantes";
import Liquidaciones from "./Secciones/Liquidaciones/Liquidaciones";
import ImagenesAsociadas from "./Secciones/ImagenesAsociadas/ImagenesAsociadas";
import Prestaciones from "./Secciones/Prestaciones/Prestaciones";
import ListadoInternaciones from "../Presentacion/Internaciones/ListadoInternaciones";
import ModalArchivos from "./Modales/AdjuntarArchivos/ModalArchivos";
import SnackMensaje from "../common/SnackBar/SnackBar";

const presentacion = (props) => {
    const classes = styles();
    const titulo =
        !props.esEdicion && !props.soloVista
            ? "Nueva presentación"
            : props.esEdicion
            ? "Editar Presentación Nº " + props.idPresentacion
            : "Presentación Nº " + props.idPresentacion;

    return (
        <Container disableGutters={true} className={classes.container}>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
            >
                <Typography className={classes.tituloPrincipal}>
                    {titulo}
                </Typography>
            </Box>
            <DatosPrestador />
            <Container className={classes.filaContainer}>
                <Typography className={classes.titulo}>
                    Documentación de la presentación
                </Typography>
            </Container>
            <TipoPresentacion />
            <Comprobantes />
            <Liquidaciones />
            <ImagenesAsociadas />
            <Prestaciones />
            <ModalArchivos />
            <ListadoInternaciones />
            <Backdrop className={classes.backdrop} open={props.mostrarBackdrop}>
                <CircularProgress color="primary" />
            </Backdrop>
            <SnackMensaje mostrar={props.estaVisible} mensaje={props.mensaje} />
        </Container>
    );
};

const mapStateToProps = (state) => ({
    ...state.snackMensajeReducer,
    mostrarBackdrop: state.nuevaPresentacionReducer.mostrarBackdrop,
    esEdicion: state.nuevaPresentacionReducer.esEdicion,
    soloVista: state.nuevaPresentacionReducer.soloVista,
    idPresentacion: state.nuevaPresentacionReducer.idPresentacion,
});

const actionCreators = {
    actualizarAtriutoPresentacion:
        actionsPresentacion.actualizarAtriutoPresentacion,
};

export default connect(
    mapStateToProps,
    actionCreators
)(withRouter(presentacion));
